import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';

import {
  Heading,
  HorizontalRule,
  Panel,
  PlaybackList,
  PlaybackKey,
  PlaybackValue,
} from '@piggybank/core';

import { apiDateToDateObject, formatPercentage } from '~/utils';
import { formatAmount, formatDateObj } from '~/genericFunctions';
import { NLS } from '~/pages/PayrollReview/payrollReviewFunctions';

import { withAppContext } from '~/AppContext';

const CreditInformationPanel = ({ data, index }) => {
  let loanOptions = get(data, 'displayData.loanOffer.loanOptions');

  return (
    <Panel>
      <Heading level={2}>
        {NLS`Credit information`}
      </Heading>
      <PlaybackList>
        <PlaybackKey>{NLS`Loan amount`}</PlaybackKey>
        <PlaybackValue type="large">{formatAmount(loanOptions, index, 'principal.amount')}</PlaybackValue>

        <HorizontalRule marginBottom={4} />

        <PlaybackKey>{NLS`Term`}</PlaybackKey>
        <PlaybackValue>{loanOptions[index].term.length} {NLS`${loanOptions[index].term.timeUnit}`}</PlaybackValue>

        <PlaybackKey>{NLS`Frequency of payment`}</PlaybackKey>
        <PlaybackValue>{NLS`${loanOptions[index].payment.periodicity}`}</PlaybackValue>

        <PlaybackKey>{NLS`Amount per payment`}</PlaybackKey>
        <PlaybackValue>{formatAmount(loanOptions, index, 'payment.amount.amount')}</PlaybackValue>

        <PlaybackKey>{NLS`First payment date`}</PlaybackKey>
        <PlaybackValue>{formatDateObj(apiDateToDateObject(loanOptions[index].payment.firstPaymentDate))}</PlaybackValue>

        <PlaybackKey>{NLS`Annual fixed interest rate`}</PlaybackKey>
        <PlaybackValue><strong>{loanOptions[index].interestRate}%</strong></PlaybackValue>

        <PlaybackKey>{NLS`CAT`}</PlaybackKey>
        <PlaybackValue><strong>{`${formatPercentage(loanOptions[index].totalAnnualCostPercentage, 1)} ${NLS`withoutVAT`}`}</strong></PlaybackValue>

        <PlaybackKey>{NLS`Date of CAT calculation`}</PlaybackKey>
        <PlaybackValue>{formatDateObj(apiDateToDateObject(loanOptions[index].totalAnnualCostCalculationDate))}</PlaybackValue>

        <PlaybackKey>{NLS`Validity of the offer`}</PlaybackKey>
        <PlaybackValue>{formatDateObj(apiDateToDateObject(loanOptions[index].offerExpiryDate))}</PlaybackValue>

        <PlaybackKey>{NLS`Commission fee`}</PlaybackKey>
        <PlaybackValue>{formatAmount(loanOptions, index, 'fees.commission.amount')}</PlaybackValue>

        <PlaybackKey>{NLS`Value added tax`}</PlaybackKey>
        <PlaybackValue marginBottom={0}>{formatAmount(loanOptions, index, 'fees.valueAddedTax.amount')}</PlaybackValue>
      </PlaybackList>
    </Panel>
  );
};

CreditInformationPanel.propTypes = {
  data: PropTypes.shape({
    displayData: PropTypes.shape({
      loanOffer: PropTypes.shape({
        loanOptions: PropTypes.arrayOf(PropTypes.shape()),
      }),
    }),
  }),
  index: PropTypes.number,
};

export default withAppContext()(CreditInformationPanel);
